import React, { useEffect, useRef, useState } from 'react';
import './ChallengesSection.css';
import { useLocation, useNavigate } from 'react-router-dom';
import challengeImage from '../../assests/salestology-img04.webp';
import challengeImage2 from '../../assests/salestology-img004.jpg';

const ChallengesSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const challenges = [
    "Lack of effective sales support infrastructure",
    "Inability to compare and contrast sales effectiveness across territories",
    "Unclear customer segmentation",
    "low adoption of Customer Relationship Management (CRM) tools",
    "Administrative tasks bog down the sales team capacity to see customers",
    "Sales leaders unable to analyze the real reasons for opportunities lost",
    "Missing out on sales opportunities due to poor sales force sizing",
    "Lost leads in the system with poor timely follow up",
    "Complicated sales process",
    "Poor selling skills training",
    "Lack of KPIs clarity and standardization",
    "Poor sales management development programs"
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.3,
        rootMargin: '0px 0px -100px 0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);
  
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToContact = (e) => {
    e.preventDefault();
    
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById('contact-section');
        if (element) {
          const elementPosition = element.offsetTop - 80; // 80px margin offset
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById('contact-section');
      if (element) {
        const elementPosition = element.offsetTop - 80; // 80px margin offset
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    }
  };

    // const challengeStyle = {
    //     backgroundImage: ` linear-gradient(90deg, rgba(27, 58, 118, 0.5) 100%, #F2295B00 100%), url(${challengeImage})`
    // };

       const challengeStyle = {
        '--challenge-image-desktop': `url(${challengeImage})`,
        '--challenge-image-mobile': `url(${challengeImage2})`
    };


  return (
    <>
      <section className="challenges-section" style={challengeStyle} ref={sectionRef}>
        <div className="challenges-container">
          <div className="challenges-content">
            <h2 className={`challenges-title ${isVisible ? 'animate' : ''}`}>
              Common Challenges Our <br/>Clients Encounter In Boosting Sales
            </h2>
            <button className={`challenges-cta ${isVisible ? 'animate' : ''}`} onClick={scrollToContact}>
              Get In Touch
            </button>
            
            <div className={`challenges-grid ${isVisible ? 'animate' : ''}`}>
              {challenges.map((challenge, index) => (
                <div key={index} className={`challenge-item ${isVisible ? 'animate' : ''}`}>
                  <i className="fas fa-dot-circle challenge-icon"></i>
                  <span className="challenge-text">{challenge}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ChallengesSection;